const cart = (state = {}, action) => {
    switch (action.type) {
        case "CART": {
            let user;
            user = action.payload

            return {
                count: user.cart_count,
                price: user.price
            };
        }
        default: {
            return state
        }
    }
}

export default cart;
